export default __webpack_public_path__ + "static/media/background.73a13b65.jpg";